/**
 * To be used with only an array of strings
 * @param useOxfordComma whether to add a comma before the "and"
 */
export const createCommaSeparatedString = (
  arr: string[],
  useOxfordComma = false
) => {
  const formattedString = createCommaSeparatedElements(arr, useOxfordComma)

  return Array.isArray(formattedString)
    ? formattedString.join('')
    : formattedString
}

/**
 * Can be used with React elements or strings or anything really
 * @param useOxfordComma whether to add a comma before the "and"
 */
export const createCommaSeparatedElements = <T>(
  arr: T[],
  useOxfordComma = false
): T[] | string => {
  if (!arr?.length) return ''

  const list = arr.reduce((acc, curr, i, array) => {
    if (i === 0) return [curr]

    return [...acc, getConjunction(array, i, useOxfordComma), curr]
  }, [])

  return list
}

const getConjunction = <T>(arr: T[], i: number, useOxfordComma = false) => {
  if (arr.length <= 1) return ''

  if (i < arr.length - 1) return ', '

  return useOxfordComma && arr.length > 2 ? ', and ' : ' and '
}
